module.exports = __webpack_public_path__ + "img/flow-desc8.0c0da013.png";